export const CKEDITOR_SRC = '/CKEditor5/ckeditor.js';

// Resolves with BalloonEditor, adding the build's script to the page when
// nothing has. The pending load rides on its script element, so every
// editor on the page waits on the same one; a failed load takes its script
// away again, so a later call can try once more.
export function loadBalloonEditor() {
  if (window.BalloonEditor) return Promise.resolve(window.BalloonEditor);

  const loading = document.head.querySelector('script[data-ckeditor-build]');
  if (loading && loading.ckeditorLoading) return loading.ckeditorLoading;

  const script = document.createElement('script');
  script.src = CKEDITOR_SRC;
  script.async = true;
  script.dataset.ckeditorBuild = 'true';
  script.ckeditorLoading = new Promise((resolve, reject) => {
    script.addEventListener('load', () => {
      if (window.BalloonEditor) {
        resolve(window.BalloonEditor);
      } else {
        script.remove();
        reject(new Error('the CKEditor build loaded without BalloonEditor'));
      }
    });
    script.addEventListener('error', () => {
      script.remove();
      reject(new Error('the CKEditor build did not load'));
    });
  });
  document.head.appendChild(script);
  return script.ckeditorLoading;
}
